import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectCreateRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-create',
	path: '/projects/:projectKey/settings/automation/blueprint/:blueprintKey',
};
